<template>
  <div class="d-flex zoom-cont flex-wrap">
    <div class="text-title mr-2">View</div>
    <div class="zoom-btn-cont mr-2">
      <span class="px-2 text-body">{{ formatPercent(zoomPercent) }}</span>
      <i
        class="fa-regular fa-arrows-rotate default-zoom-btn px-2"
        @click="resetZoom"
      />
    </div>
    <input
      v-model.number="zoom"
      type="range"
      :step="defaultZoom / 4"
      :min="defaultZoom / 4"
      :max="(defaultZoom / 4) * 7"
      class="cursor-pointer"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref, watch } from "vue";

import CONSTANTS from "@/Constants";
import { formatPercent } from "@/mixins";
const { SCHEDULE_DEFAULT_ZOOM } = CONSTANTS;

const props = defineProps<{ modelValue: number }>();
const emit = defineEmits(["update:modelValue"]);
const defaultZoom = ref(SCHEDULE_DEFAULT_ZOOM);

const zoom = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit("update:modelValue", val);
  }
});

const zoomPercent = computed(() => zoom.value / SCHEDULE_DEFAULT_ZOOM);

watch(zoom, (val) =>
  localStorage.setItem("schedule-board-zoom", val.toString())
);

onBeforeMount(() => {
  const cachedZoom = localStorage.getItem("schedule-board-zoom");
  if (cachedZoom) {
    zoom.value = parseFloat(cachedZoom);
  }
});

function resetZoom() {
  zoom.value = SCHEDULE_DEFAULT_ZOOM;
}
</script>

<style lang="scss" scoped>
.zoom-btn {
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
}
.zoom-cont {
  font-size: 0.9em;
  display: flex;
  align-items: center;
  position: relative;
  top: -5px;
}
.zoom-btn-cont {
  padding: 4px;
  border-radius: 4px;
  border: 1px solid var(--neutral-gray-400);
}
.default-zoom-btn {
  color: var(--text-links);
  border-left: 1px solid var(--neutral-gray-400);
  cursor: pointer;
}

@media (max-width: 930px) {
  .zoom-cont {
    top: 0;
  }
}
</style>
